<template>
  <div class="specialization-delete">
    <custom-scrollbar>
      <div
        class="crm-container specialization-container"
      >
        <div class="description">
          Вы уверены, что хотите удалить специализацию <br>
          «<span>{{ specialization.title }}</span>»?
        </div>
        <div class="crm-wrapper-buttons">
          <!-- <base-button
            :type="$const.SECONDARY_BUTTON"
            class="crm-button"
            @click="onClickClose"
          >
            Отменить
          </base-button> -->

          <base-button
            :type="$const.WARNING_BUTTON"
            :loading="isDeleting"
            class="crm-button"
            @click="onClickDelete"
          >
            Удалить
          </base-button>
        </div>
      </div>
    </custom-scrollbar>
  </div>
</template>

<script>
import Bus from '@/eventBus';
import { mixinRoles } from '@/mixins';

import {
  BaseButton,
} from '@/components/base';

export default {
  name: 'SpecializationDeleteModal',
  components: {
    BaseButton,
  },
  mixins: [mixinRoles],
  props: {
    specialization: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  methods: {
    onClickClose() {
      this.$emit('vuedals:close');
    },
    async onClickDelete() {
      this.isDeleting = true;

      try {
        await this.$store.dispatch(this.$types.SPECIALIZATION_DELETE, this.specialization.id);
        Bus.$emit('specializations:update');
        this.$emit('vuedals:close');
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.specialization-container {
  flex-direction: column;
  align-items: center;
}
.crm-wrapper-buttons {
  margin-top: 35px;
}
.description {
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  span {
    color: $blue-dark;
    font-weight: 500;
  }
}
</style>
